import { utils, writeFile } from 'xlsx';

const jsonToSheet = utils.json_to_sheet;
const bookNew = utils.book_new;
const bookAppendSheet = utils.book_append_sheet;

export { jsonToSheet, bookNew, bookAppendSheet, writeFile };